<template>
    <input class="form-input rounded-md shadow-sm" :value="value" :placeholder="placeholder" @input="$emit('update:modelValue', $event.target.value)" ref="input">
</template>

<script>
    export default {
        props: ['modelValue', 'placeholder'],
        computed: {
            value() {
                return this.modelValue;
            },
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>

